import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const OrderBy = props => {
  function handleOrderChoice(e) {
    props.onSelectOrder(e.target.value)
  }

  const sortArray = [
    { id: '', title: 'Sort by' },
    { id: 'en', title: 'Sort by' },
    { id: 'be', title: 'Sorteer op' },
    { id: 'da', title: 'Sortér efter' },
    { id: 'fi', title: 'Järjestä' },
    { id: 'fr', title: 'Trier par' },
    { id: 'fr-be', title: 'Trier par' },
    { id: 'de', title: 'Sortieren nach' },
    { id: 'it', title: 'Ordina per' },
    { id: 'nl', title: 'Sorteer op' },
    { id: 'no', title: 'Sorter etter' },
    { id: 'es', title: 'Ordenar por' },
    { id: 'sv', title: 'Sortera efter' },
    { id: 'uk', title: 'Sort by' },
    { id: 'gb', title: 'Sort by' },
    { id: 'us', title: 'Sort by' }
  ]
  let sortLabel = (props.language) ? sortArray.find(
    ({ id }) => id === props.language
  ) : 'Sort by';
  sortLabel = sortLabel.title ? sortLabel.title : 'Sort by';

  const brandArray = [
    { id: '', title: 'Brand' },
    { id: 'en', title: 'Brand' },
    { id: 'be', title: 'Merk' },
    { id: 'da', title: 'Mærke' },
    { id: 'fi', title: 'Brändi' },
    { id: 'fr', title: 'Marque' },
    { id: 'fr-be', title: 'Marque' },
    { id: 'de', title: 'Marke' },
    { id: 'it', title: 'Marca' },
    { id: 'nl', title: 'Sorteer op' },
    { id: 'no', title: 'Merke' },
    { id: 'es', title: 'Marca' },
    { id: 'sv', title: 'Märke' },
    { id: 'uk', title: 'Brand' },
    { id: 'gb', title: 'Brand' },
    { id: 'us', title: 'Brand' }
  ]
  let brandLabel = (props.language) ? brandArray.find(
    ({ id }) => id === props.language
  ) : 'Brand';
  brandLabel = brandLabel.title ? brandLabel.title : 'Brand';

  return (
    <div className="c-shop-select-filter">
      <select
        value={props.order}
        onChange={handleOrderChoice}
        disabled={props.postsLoading}
        className="c-shop-select-filter__select"
      >
        <option value="">{sortLabel}</option>
        <option value="title_asc">{brandLabel} (a-z)</option>
        <option value="title_desc">{brandLabel} (z-a)</option>
      </select>
    </div>
  )
}

export default OrderBy


// WEBPACK FOOTER //
// ./src/js/shop/components/Orderby.js